import styles from "./productCard.scss";
import React, { useEffect, useState } from "react";
import { ProductFlag } from "../productFlag/productFlag";
import Heart from "./heart.png";
import ResponsiveImg from "../responsiveImg/responsiveImg";
import NewSpinner from "../newSpinner/newSpinner";
import { useQueryParams } from "../../hooks/useQueryParams";
import { getQueryUTMString } from '../../utils/helper';

function ProductCard(props) {
  const queryParams = useQueryParams();
  const [isAddedWishlist, setIsAddedWishlist] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [param, setParam] = useState('');
  const intlNumberFormatter = new Intl.NumberFormat("en-US");
  const { product, lg, sm, isHeart, Link, onAddToCart, flexiWidth } = props;
  //const NextLink = Link || "a";
  // const cardClass =
  //   styles["product-card"] +
  //   " " +
  //   (lg ? styles["product-card-lg"] : sm ? styles["product-card-sm"] : "");

  const cardClass =
    styles["product-card"] +
    (sm ? " " + styles["product-card-sm"] : "") +
    (flexiWidth ? " " + styles["product-card-flexi-width"] : "");

  const toggleWishlist = () => {
    setIsAddedWishlist(!isAddedWishlist);
  };

  const handleAddToCart = async () => {
    try {
      setIsLoading(true);
      await onAddToCart(product);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (queryParams) {
      setParam(getQueryUTMString('?'))
    }
  }, [queryParams])
  return (
    <div className={cardClass}>
      <div
        className={styles["heart-div"]}
        style={isHeart ? null : { display: "none" }}
      >
        {isAddedWishlist === false ? (
          <svg
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="black"
            onClick={toggleWishlist}
            className={styles["heart"]}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.20586 1.9418C11.1019 0.0115157 14.1636 -0.23877 16.1453 1.42752C18.727 3.60123 18.343 7.13952 16.5087 9.01495L10.495 15.1418C10.1521 15.4915 9.69614 15.6835 9.20586 15.6835C8.719 15.6835 8.25957 15.4881 7.91671 15.1384L1.903 9.01152C0.0652864 7.13609 -0.311856 3.5978 2.26643 1.42752C4.24814 -0.242198 7.30986 0.0115157 9.20586 1.9418ZM9.32243 13.9829L15.3361 7.85609C16.5773 6.59094 16.8379 4.16352 15.0859 2.6858C13.759 1.56809 11.7019 1.72923 10.4059 3.04923L9.20586 4.27323L8.00586 3.04923C6.71671 1.73609 4.65957 1.56809 3.32586 2.68923C1.57043 4.16694 1.82414 6.58066 3.07557 7.85609L9.08929 13.9829C9.17157 14.0652 9.24014 14.0652 9.32243 13.9829Z"
              fill="#2C2C2C"
            />
          </svg>
        ) : (
          <img
            src={Heart}
            alt=""
            height="16px"
            width="18px"
            onClick={toggleWishlist}
            className={styles["heart"]}
          />
        )}
      </div>
      <div className={styles["product-flag"]}>
        <ProductFlag productFlags={product.labels} />
      </div>
      <a href={`/products/${product.itemCode}${param}`}>
        <div className={styles["product-card-img"]}>
          <ResponsiveImg
            src={product?.image}
            alt={product?.productName}
            showFallbackImg
          />
        </div>
      </a>

      <div className={styles["product-card-content"]}>
        <a href={`/products/${product.itemCode}${param}`}>
          <p className={styles["title"]}>{product.productBrand}</p>
        </a>
        <a href={`/products/${product.itemCode}${param}`}>
          <p className={styles["title"]}>{product.productName}</p>
        </a>

        <div className={styles["inline"]}>
          <div className={styles["price-container"]}>
            <div className={styles["price"]} translate="no">
              $ {intlNumberFormatter.format(Number(product.price))}
            </div>
            {/* <p className={styles["left"]}>{product.saleCnt}K 賣</p> */}
          </div>
          <div className={styles["cart-clickable"]} onClick={handleAddToCart}>
            <div
              className={styles["cart-icon"]}
              style={isLoading ? { background: "#707070" } : null}
            >
              {isLoading ? (
                <NewSpinner size="sm" />
              ) : (
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0787 13.3396C15.0787 14.3263 14.2966 15.1262 13.3318 15.1262C12.367 15.1262 11.5849 14.3263 11.5849 13.3396V13.3377C11.5849 13.0739 11.6899 12.6745 11.8192 12.4463H7.85678C7.98612 12.6745 8.09106 13.0739 8.09106 13.3377V13.3396C8.09106 14.3263 7.30893 15.1262 6.34415 15.1262C5.37937 15.1262 4.59724 14.3263 4.59724 13.3396C4.59724 12.8595 4.78273 12.424 5.08402 12.103L3.18443 2.17329H0.994233C0.813347 2.17329 0.666687 2.0233 0.666687 1.8383V1.16833C0.666687 0.983329 0.813347 0.833336 0.994233 0.833336H3.72378C4.03707 0.833336 4.30653 1.06023 4.36669 1.37467L4.60489 2.61995H15.7336C16.1514 2.61995 16.4625 3.01464 16.3737 3.43223L15.1395 9.23872C15.074 9.54672 14.8075 9.76639 14.4994 9.76639H5.97211L6.22841 11.1063H13.9298C14.3477 11.1063 14.6587 11.5011 14.5699 11.9187L14.5417 12.0515C14.8725 12.3766 15.0787 12.8333 15.0787 13.3396ZM5.71581 8.42648H13.9716L14.9209 3.95995H4.86118L5.71581 8.42648ZM6.34415 14.0096C5.98291 14.0096 5.68906 13.7091 5.68906 13.3397C5.68906 12.9702 5.98291 12.6697 6.34415 12.6697C6.70539 12.6697 6.99924 12.9702 6.99924 13.3397C6.99924 13.7091 6.70539 14.0096 6.34415 14.0096ZM12.6767 13.3397C12.6767 13.7091 12.9706 14.0096 13.3318 14.0096C13.693 14.0096 13.9869 13.7091 13.9869 13.3397C13.9869 12.9702 13.693 12.6697 13.3318 12.6697C12.9706 12.6697 12.6767 12.9702 12.6767 13.3397Z"
                    fill="white"
                  />
                </svg>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ProductCard.defaultProps = {
  product: {},
  lg: false,
  sm: false,
  isHeart: false,
  Link: "a",
  onAddToCart: () => { },
};

export default ProductCard;
